module.exports = __webpack_public_path__ + "img/ali.cd3468b9.jpeg";